import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import PieHooks from "./PieHooks";

function ResultBlk(props) {
    const { t } = props;
    const [resultData, setResultData] = useState({
        data: {
            graphData: [],
            mostProbableColorData: []
        }
    })

    //Hook will trigger on graphData props got changed
    useEffect(() => {
        //update resultdata state
        setResultData({
            ...resultData,
            data: {
                graphData: props.graphData,
                mostProbableColorData: props.mostProbableColorData
            }
        })
    }, [props.graphData])

    if (resultData.mostProbableColorData !== null) {
        const gData = resultData.data.graphData.map((item) => {
            return ({
                title: item.colorName,
                value: item.percentage,
                color: item.colorCodeHexa
            })
        })
        const colorName = ['']
        let connector = 0
        let colorLength = resultData.data.mostProbableColorData.length
        let restColors = []
        let firstColor = ''
        let singleColor = ''
        let singeleColorCode = ''
        let firstColorCode = ''
        return (
            <div>
                <div className="results">
                    <div>
                        <div className="heading">{t('EyeColorPredictor_EyeColorProbability')}</div>
                        {/* Result Information */}
                        <div className="words">

                            <div className="overview">
                                <div className="message">
                                    {
                                        resultData.data.mostProbableColorData.map((item, index) => {
                                            if (colorLength === 1 && index === 0) {
                                                singleColor = item.colorName;
                                                singeleColorCode = item.colorCodeHexa;
                                            } else {
                                                if (index === 0) {
                                                    firstColor = item.colorName
                                                    firstColorCode = item.colorCodeHexa
                                                } else
                                                    restColors.push(item)
                                            }
                                        })
                                    }
                                    {
                                        colorLength !== 1 ?
                                            <span>
                                                <span className="predicted-baby-eye-color" style={{ color: firstColorCode, fontWeight: 'bold' }}>
                                                    {firstColor}
                                                </span>
                                                {
                                                    restColors.map((color, index) => {
                                                        return <React.Fragment key={index}>
                                                            <span className="predicted-baby-eye-msg">{' ' + t('EyeColorPredictor_AndText') + ' '}</span>
                                                            <span className="predicted-baby-eye-color" style={{ color: color.colorCodeHexa, fontWeight: 'bold' }}>{color.colorName}</span>
                                                        </React.Fragment>
                                                    })
                                                }
                                                <span className="predicted-baby-eye-msg">{' ' + t('EyeColorPredictor_MostLikelyColors') + ' '}</span>
                                            </span>
                                            :
                                            <span>
                                                <span className="predicted-baby-eye-color" style={{ color: singeleColorCode, fontWeight: 'bold' }}>{singleColor}</span>
                                                <span className="predicted-baby-eye-msg">{' ' + t('EyeColorPredictor_MostLikelyColor') + ' '}</span>
                                            </span>
                                    }
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="cols">
                        <div className="graph">
                            {/* Call PieHooks component to display the chart */}
                            <PieHooks
                                data={gData}
                                width={300}
                                height={300}
                                innerRadius={0}
                                outerRadius={100}
                            />

                            <div className="overview">
                                <div className="eye-color-prediction-wrapper eye active ">
                                    {/* {                                    
                                resultData.data.mostProbableColorData.map((item, index) => {                                                                               
                                    let data = item.colorName.toLowerCase()
                                    colorName.push(data + connector)
                                    return <i key={index} className=" fa fa-eye first-parent-eye" style={{ color: item.colorCodeHexa }}>
                                            <i key={index} className=" fa eye-color-prediction second-parent-eye" style={{ "color": "#cb2026" }}></i>
                                            </i>
                                })                                    
                            } */}

                                    <div className="eye-color-combine-result">

                                        {
                                            colorLength !== 1 ?
                                                <span>

                                                    <i className=" fa fa-eye first-parent-eye" style={{ color: firstColorCode }}></i>
                                                    {
                                                        restColors.map((color, index) => {
                                                            return <React.Fragment key={index}>
                                                                <i key={index} className=" fa eye-color-prediction second-parent-eye" style={{ color: color.colorCodeHexa }}></i>
                                                            </React.Fragment>
                                                        })
                                                    }
                                                </span>
                                                :
                                                <span>
                                                    <i className=" fa fa-eye first-parent-eye" style={{ color: singeleColorCode }}>
                                                        {/* <i key={index} className=" fa eye-color-prediction second-parent-eye" style={{ "color": "#cb2026" }}></i> */}
                                                    </i>
                                                </span>

                                        }

                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    } else {
        return <></>
    }
}

export default withTranslation()(ResultBlk);